import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.is-array";
import React from "react";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import _ from 'lodash';

function computeProps(incomingProps, defaultProps) {
  var computedProps = {};
  incomingProps = _.clone(incomingProps);
  delete incomingProps.children;
  var incomingPropsStyle = incomingProps.style;
  delete incomingProps.style;
  if (incomingProps) _.merge(computedProps, defaultProps, incomingProps);else computedProps = defaultProps;

  if (incomingPropsStyle) {
    var computedPropsStyle = {};
    computedProps.style = {};

    if (Array.isArray(incomingPropsStyle)) {
      _.forEach(incomingPropsStyle, function (style) {
        if (typeof style == "number") {
          _.merge(computedPropsStyle, StyleSheet.flatten(style));
        } else {
          _.merge(computedPropsStyle, style);
        }
      });
    } else {
      if (typeof incomingPropsStyle == "number") {
        computedPropsStyle = StyleSheet.flatten(incomingPropsStyle);
      } else {
        computedPropsStyle = incomingPropsStyle;
      }
    }

    _.merge(computedProps.style, defaultProps.style, computedPropsStyle);
  }

  return computedProps;
}

;
export default computeProps;